import { render, staticRenderFns } from "./config.vue?vue&type=template&id=cfaf5094&"
import script from "./config.vue?vue&type=script&lang=js&"
export * from "./config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cfaf5094')) {
      api.createRecord('cfaf5094', component.options)
    } else {
      api.reload('cfaf5094', component.options)
    }
    module.hot.accept("./config.vue?vue&type=template&id=cfaf5094&", function () {
      api.rerender('cfaf5094', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/merchant/child/config.vue"
export default component.exports